/**
 * Wave C · global trigger for the shared "become an insider" sheet.
 * Any gated feature calls openInsiderUnlocks(reason) to open the sheet
 * mounted globally in MemberShell.
 */
export const UNLOCKS_EVENT = "ww:unlocks:open";
export const SIGNUP_CELEBRATION_EVENT = "ww:signup:celebrate";
export const JUST_SIGNED_IN_KEY = "watuwako:just_signed_in";

export function openInsiderUnlocks(reason) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(UNLOCKS_EVENT, { detail: { reason: reason || "" } }));
}

/** Fire after a brand-new account lands (post sign-in / post trial start). */
export function celebrateSignup() {
  if (typeof window === "undefined") return;
  try { sessionStorage.setItem(JUST_SIGNED_IN_KEY, "1"); } catch {}
  window.dispatchEvent(new CustomEvent(SIGNUP_CELEBRATION_EVENT));
}

/** Pop the once-per-session signup flag (used by the celebration listener). */
export function consumeSignupFlag() {
  if (typeof window === "undefined") return false;
  try {
    const v = sessionStorage.getItem(JUST_SIGNED_IN_KEY);
    if (v) sessionStorage.removeItem(JUST_SIGNED_IN_KEY);
    return !!v;
  } catch { return false; }
}
